import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'phonenumber/filter';

export function useGetPhoneNumbers({
	filterRequest,
	impersonationContext,
	pageSize = 25,
	refetchOnWindowFocus = false,
	sortBy,
	sort,
}: {
	filterRequest: Api.TelephonyConfigurationFilter;
	impersonationContext: Api.IImpersonationContext;
	pageSize?: number;
	refetchOnWindowFocus?: boolean;
	sortBy?: string;
	sort?: 'asc' | 'desc';
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.ITelephonyConfiguration>>({
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ITelephonyConfiguration>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { pageSize, pageToken: pageParam, sort, sortBy },
					urlPath: BASE_QUERY_KEY,
				}),
				'POST',
				filterRequest
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext, filterRequest, pageSize, sortBy, sort],
		refetchOnWindowFocus,
		initialPageParam: '',
	});
}

export const invalidateGetPhoneNumbers = (
	impersonationContext: Api.IImpersonationContext,
	filterRequest?: Api.TelephonyConfigurationFilter
) => {
	return reactQueryClient.invalidateQueries({
		queryKey: [BASE_QUERY_KEY, impersonationContext, filterRequest].filter(Boolean),
	});
};
